import { Component, OnInit, Input } from "@angular/core";
import { RiskIndicator } from "../../../interfaces/riskIndicator";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-indicator-navigation",
  templateUrl: "./indicator-navigation.component.html",
  styleUrls: ["./indicator-navigation.component.scss"],
})
export class IndicatorNavigationComponent implements OnInit {
  @Input() currentlyShownIndicator: RiskIndicator;
  @Input() allRiskIndicators: RiskIndicator[];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {}

  getPreviousRiskIndicator(): RiskIndicator {
    const currentIndex = this.allRiskIndicators.findIndex(
      (r) => r._id === this.currentlyShownIndicator._id
    );

    if (currentIndex === 0) {
      return this.allRiskIndicators[this.allRiskIndicators.length - 1];
    } else {
      return this.allRiskIndicators[currentIndex - 1];
    }
  }

  getNextRiskIndicator(): RiskIndicator {
    const currentIndex = this.allRiskIndicators.findIndex(
      (r) => r._id === this.currentlyShownIndicator._id
    );

    if (currentIndex === this.allRiskIndicators.length - 1) {
      return this.allRiskIndicators[0];
    } else {
      return this.allRiskIndicators[currentIndex + 1];
    }
  }

  navigateToPrevious() {
    const prev = this.getPreviousRiskIndicator();
    const projectId = this.route.snapshot.params["id"];
    this.router.navigate([
      "/projects",
      projectId,
      "retrospectives",
      prev.shortId,
    ]);
  }

  navigateToNext() {
    const next = this.getNextRiskIndicator();
    const projectId = this.route.snapshot.params["id"];
    this.router.navigate([
      "/projects",
      projectId,
      "retrospectives",
      next.shortId,
    ]);
  }

  navigateToSpecific(indicatorId) {
    const projectId = this.route.snapshot.params["id"];
    this.router.navigate([
      "/projects",
      projectId,
      "retrospectives",
      indicatorId,
    ]);
  }

  onKeyDown(event) {
    if (event.key === "ArrowLeft") {
      this.navigateToPrevious();
    }

    if (event.key === "ArrowRight") {
      this.navigateToNext();
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/risk-indicator/indicator-navigation/indicator-navigation.component.ts